export function getAppVersion() {
  return process.env.REACT_APP_VERSION;
}

export function getAppName() {
  return process.env.REACT_APP_NAME;
}
